import { ResultPage } from '@Entities/result-page'
import { PublisherModelWithWorksCount } from '@Entities/work/publisher-model-with-works-count'
import { PublisherSearchResults } from '@Entities/work/publisher-search-results'

export interface PublisherSearchResultModel {
    count: number
    results: PublisherSearchResults[]
}

export const toPublisherSearchResultModel = (
    page: ResultPage<PublisherModelWithWorksCount>
): PublisherSearchResultModel => ({
    count: page.totalElements,
    results: page.content.map((publisher) => ({ entity: publisher })),
})
